import React from 'react';
export function AdvertorialHeader() {
  return <header className="w-full bg-gray-800 py-3 px-4" data-id="element-1">
      <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-2">
        <span className="text-white font-semibold text-sm tracking-wide" data-id="element-3">
          Advertorial
        </span>
        <div className="flex items-center gap-2 text-white text-sm" data-id="element-4">
          <span className="text-lg" data-id="element-5">🇺🇸</span>
          <span className="font-medium" data-id="element-6">Trending in the US</span>
        </div>
      </div>
    </header>;
}